/***
 *
 *   CARD
 *   Universal container for grouping UI components together.
 *   Styling matches ui-reference/src/components/ui/card.tsx.
 *
 *   PROPS
 *   variant: surface/elevated/interactive (default: surface)
 *   title: title string (optional)
 *   description: sub-title string (optional)
 *   loading: boolean to toggle the loading animation (optional)
 *   center: center align the card
 *   noPadding: remove the padding
 *   restrictWidth: restrict the width of the card on large screens
 *   footer: node rendered in the footer row (optional)
 *
 **********/

import { Loader, ClassHelper } from 'components/lib';
import Style from './card.tailwind.js';

export function Card(props) {
    const cardStyle = ClassHelper(Style, {
        [props.variant || 'surface']: true,
        center: props.center,
        noPadding: props.noPadding,
        loading: props.loading,
        className: props.className,
        last: props.last,
        restrictWidth: props.restrictWidth,
    });

    return (
        <section className={cardStyle}>
            {(props.title || props.description) && (
                <header className={Style.header}>
                    {props.title && <h3 className={Style.title}>{props.title}</h3>}
                    {props.description && <p className={Style.description}>{props.description}</p>}
                </header>
            )}

            {props.loading ? (
                <Loader />
            ) : (
                <div className={props.centerFit ? 'md:mx-auto md:max-w-[500px]' : 'h-full'}>{props.children}</div>
            )}

            {props.footer && <footer className={Style.footer}>{props.footer}</footer>}
        </section>
    );
}
